const Version = {
    Number: "26.1",
    Title: "January 2026 Update",
    WIP: true,
    WIP_Number: "2"
}

export default {Version}